import { ListPanelWrapper } from '../../components/ListPaneWrapper';
import { ValueDisplayWithLabel } from '../../components/ValueDisplay';
import { ICalendar } from './types';
import { themedUseStyletron } from '../../../theme/customTheme';
import { FormattedMessage, useIntl } from 'react-intl';
import { useMemo } from 'react';
import { hasEntries } from './utils';
import { LabelMedium, ParagraphSmall } from 'baseui/typography';

export function ListPanel(props: ICalendar) {
    const [css, theme] = themedUseStyletron();
    const intl = useIntl();

    const fg = props.isOn ? theme.appColors.aggregate.on : theme.appColors.aggregate.off;
    const noEntries = useMemo(() => !hasEntries(props), [props]);

    return (
        <ListPanelWrapper  {...props}>
           {noEntries ?
                <LabelMedium className={css({ color: theme.colors.warning600})}><FormattedMessage id='Calendar.noEntries' defaultMessage={'Empty'}></FormattedMessage></LabelMedium>
                :
                <ValueDisplayWithLabel color={fg} label={intl.formatMessage({ id: "Calendar.Current", defaultMessage: "currently" })} small value={props.isOn} dimension=""></ValueDisplayWithLabel>
            }

        </ListPanelWrapper>
    );
}